import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export default function useRequireAuth(redirectPath = '/login') {
  const navigate = useNavigate();

  // useMemoで毎回新しいオブジェクトを返さないようにする
  const userInfo = useMemo(() => {
    return JSON.parse(localStorage.getItem('userInfo') || '{}');
  }, []);

  useEffect(() => {
    if (!userInfo || Object.keys(userInfo).length === 0) {
      navigate(redirectPath);
    }
  }, [userInfo, navigate, redirectPath]);

  return userInfo;
}